export const deleteCodePipeline = `
    mutation deleteCodePipeline($input: DeleteCodePipelineInput!) {
        deleteCodePipeline(input:$input) {
            name
            arn
        }
}`;

export const importCodePipeline = `
    mutation importCodePipeline($input: ImportCodePipelineInput!) {
        importCodePipeline(input:$input) {
            id
            name
            description
            pipelineType
            pipelineStatus
            templateId
            codeRepositoryName
            branchName
            stackName
            originalStackName
            buildCommand
            createdByUsername
            created
        }
}`;

export const importAllCodePipelines = `
    mutation importAllCodePipelines {
        importAllCodePipelines {
            imported {
              id
              name
              pipelineType
              pipelineStatus
            }
            skipped
            errors
        }
}`;

export const migrateCodePipeline = `
    mutation migrateCodePipeline($input: MigrateCodePipelineInput!) {
        migrateCodePipeline(input:$input) {
            id
            name
            description
            pipelineType
            pipelineStatus
            templateId
            codeRepositoryName
            branchName
            stackName
            originalStackName
            buildCommand
            createdByUsername
            created
        }
}`;
